import React, { useState } from "react";
import { ui } from "../constants";
import { Button } from "./Button";
import styled from "@emotion/styled";
import { HowToReg, Person } from "@mui/icons-material";
import { ButtonMenu } from "./ButtonMenu";
import { useUser } from "./UserProvider";
import { useSettings } from "./SettingsProvider";

const SubmitButton = styled(Button)`
  margin: 0 0 0 0px;
  padding: 0.7em 0.8em 0.7em 0.8em;
`;

const VariaButton = styled(Button)`
  color: black;
  background-color: ${ui.stdColor60};
  &:hover {
    background-color: ${ui.stdColor50};
    color: black;
  }
  &:active {
    background-color: ${ui.stdColor100};
    color: white;
  }
  &[aria-pressed="true"] {
    background-color: ${ui.stdColor100};
    color: white;
  }
  height: 100%;
  font-size: 1em;
`;

const LoginButton = styled(VariaButton)`
  margin-right: 25px;
  /* border: 1px solid; */
`;

const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 15px 15px 15px;
  background-color: ${ui.menu.backgroundColor};
`;

export const Login = () => {
  const { login, logout, auth } = useUser();
  const {
    settings: { lang },
  } = useSettings();

  const [show, setShow] = useState(false);

  const button = (
    <LoginButton
      tooltip={ui.tooltips.login[lang]}
      log="login_menu"
      icon={auth.loggedIn ? <HowToReg /> : <Person />}
      iconPosition="left"
      iconChildrenSpace="0.35em"
      ariaPressed={show}
      onMouseDown={() => setShow(true)}
    >
      {auth.loggedIn ? auth.username : ui.labels.login[lang]}
    </LoginButton>
  );

  const logoutForm = (
    <LoginForm
      onSubmit={(event) => {
        logout();
        setShow(false);
        event.preventDefault();
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter") logout();
      }}
    >
      <SubmitButton type="submit">Logout</SubmitButton>
    </LoginForm>
  );

  const loginForm = (
    <LoginForm
      onSubmit={(event) => {
        login();
        event.preventDefault();
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter") login();
      }}
    >
      <SubmitButton type="submit">Login</SubmitButton>
    </LoginForm>
  );

  return (
    <ButtonMenu
      button={button}
      show={show}
      horizontal={true}
      onExit={() => setShow(false)}
    >
      {auth.loggedIn ? logoutForm : loginForm}
    </ButtonMenu>
  );
};
